import request from '../utils/request';
// 身份认证
export function auth(data) {
 let formData = new FormData();
  Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
  }); 

   return request({
    url: '/frontCommon/realNameVerification',
    method: 'post',
    data: formData,
  });
}

//图片上传
export function uploadImg(data){
  return request({
    url:'/frontCommon/upload',
    method:'post',
    data:data
  })
}
//获取token
export function getToken(data){
  return request({
    url:'/wxConfigure',
    method:'get',
    data:data 
  })
}